import type { TImageFilterId } from "./ImageToolsSections";

export const getEditorSelectionKey = (
  imageIndex: number,
  toolId: TImageFilterId,
) => `${imageIndex}:${toolId}`;

export const getInitialReviewTool = ({
  appliedFilters,
  warningToolIds,
  editableToolIds,
}: {
  appliedFilters: readonly TImageFilterId[];
  warningToolIds: ReadonlySet<TImageFilterId>;
  editableToolIds: ReadonlySet<TImageFilterId>;
}): TImageFilterId | null =>
  appliedFilters.find((toolId) => warningToolIds.has(toolId)) ??
  appliedFilters.find((toolId) => editableToolIds.has(toolId)) ??
  appliedFilters[0] ??
  null;

export const getAdjacentToolIndex = ({
  currentIndex,
  key,
  toolCount,
}: {
  currentIndex: number;
  key: string;
  toolCount: number;
}) => {
  if (toolCount <= 0) return -1;
  if (key === "Home") return 0;
  if (key === "End") return toolCount - 1;
  if (key === "ArrowRight" || key === "ArrowDown") {
    return (currentIndex + 1) % toolCount;
  }
  if (key === "ArrowLeft" || key === "ArrowUp") {
    return (currentIndex - 1 + toolCount) % toolCount;
  }
  return currentIndex;
};
